import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuNavigationService {

  private _currentMenuWatch = new BehaviorSubject<MenuDetail>(null);

  public currentMenu(): Observable<MenuDetail> {
    return this._currentMenuWatch;
  }

  constructor() { }

  navigate(menuId: string, show: boolean): void {
    this._currentMenuWatch.next({ menuId: menuId, showMenu: show });
  }
}

export class MenuDetail {
  menuId: string;
  showMenu: boolean;
}